import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
// import { loader_image } from "../_components/Imagepath";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import $ from "jquery";

import PropTypes from 'prop-types';

import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';
const DecaySaleGroupbyDate = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  // const [dataa, setDataa] = useState([]);
  const [permission, setPermission] = useState({});
 let season_id = localStorage.getItem("season_id");

  // const [statusOptions, setStatusOptions] = useState([]);
  // const [paidprice, setPaidprice] = useState(0);
  // const [unpaidprice, setUunpaidprice] = useState(0);
  useEffect(() => {
        setPermission(FindModuleById(281)); 
console.log(permission);

    axios
      .get(`/decay-sales/listing-groupby-date/${season_id+'_'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.groupby_date);
          setData(response.data.data.sales);
         // setDataa(response.data.data.sales);
          // let sales =response.data.data.sales;
          // let sales_unpaid =response.data.data.sales_unpaid;
          // const paidprice = sales.filter(item => item.payment_status === 1).reduce((sum, item) => sum + item.total_price, 0);
          // const unpaidprice = sales_unpaid.filter(item => item.payment_status === 0).reduce((sum, item) => sum + item.total_price, 0);
          // setPaidprice(paidprice);
          // setUunpaidprice(unpaidprice);
        
 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  // let raw_data_invoice ='';
  // if(value.invoice){
  //   AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
  //   AWS.config.update({
  //   accessKeyId: AWS_ACCESS_KEY_ID,
  //   secretAccessKey: AWS_SECRET_ACCESS_KEY,
  //   region: AWS_DEFAULT_REGION,
  //   signatureVersion: 'v4',
  //   });
  //   const s3 = new AWS.S3();
  //   var params = {Bucket: AWS_BUCKET, Key: value.invoice};
  //   raw_data_invoice = s3.getSignedUrl('getObject', params);
  
  // }




const editItem = (item)=>{
  window.location.href = "/decay-sales-edit/"+item;
}
const viewItem = (item)=>{
  window.location.href = "/decay-sales-view/"+item;
}


const deleteItem = (item) => {
  Swal.fire({
    title: 'Do you really want to delete this record?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'DELETE'
  }).then((result) => {
    if (result.isConfirmed) {
      axios.get(`/decay-sales/delete/${season_id+'-'+item}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/decay-sales";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }
  });
}

const InvoiceNumberCell = ({ row }) => (
  <a href={`/decay-sales-view/${row.original.id}`} className="">
    {row.original.invoice_number}
  </a>
);

InvoiceNumberCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      invoice_number: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
const TotalQuantityCell = ({ row }) => {
  const total_decay = row.original.items || [];
  const totalNetWeight = total_decay.reduce((sum, item) => sum + (item.quantity || 0), 0);
  return <span>{totalNetWeight}</span>;
};

TotalQuantityCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          quantity: PropTypes.number,
        })
      ),
    }),
  }).isRequired,
};

const PaymentStatusCell = ({ row }) => (
  <div className="btn-group custom-table-btn-group">
    <button
      type="button"
      className="btn btn-block dropdown-toggle me-1"
      id={`status-production-${row.original.id}`}
      style={{
        backgroundColor: row.original.status?.bg_color || 'transparent',
        color: row.original.status?.color || 'black',
      }}
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {row.original.status?.title || ''}
    </button>
    <div className="dropdown-menu">
      {statusOptions &&
        statusOptions.map((shipp) => (
          <button
            key={shipp.id}
            className="dropdown-item btn btn-block"
            style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
            onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
          >
            {shipp.title}
          </button>
        ))}
    </div>
  </div>
);

PaymentStatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      status: PropTypes.shape({
        title: PropTypes.string,
        bg_color: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const columns = [
  {
    header: 'Invoice Number',
    accessorFn: (row) => `${row.invoice_number}`,
    Cell: InvoiceNumberCell,
  },
  {
    accessorKey: 'date', 
    header: 'Date',
  },
  {
    header: 'Customer',
    accessorFn: (row) => (row.customer ? row.customer.name : ''),
  },
  {
    header: 'Total Quantity',
    Cell: TotalQuantityCell,
  },
  {
    accessorKey: 'total_price',
    header: 'Total Amount',
  },
 
  // {
  //   header: 'Payment Status',
  //   accessorFn: (row) => row.status?.title || '',
  //   Cell: PaymentStatusCell,
  // },
  {
    header: 'Payment Method',
    accessorFn: (row) => row.method?.title || '',
  },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
];


 

  const changeOrderStatus = (user_id, status,type) =>{

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/decay-sales/change-status/${season_id+'-'+user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              console.log(response.data.data.paymentstatus);
              if (response.data.code === 200) {
                $("#status-"+type+"-"+user_id).text(response.data.data.paymentstatus.title);
                $("#status-"+type+"-"+user_id).css('background-color',response.data.data.paymentstatus.bg_color);
                $("#status-"+type+"-"+user_id).css('color',response.data.data.paymentstatus.color);

                
                axios
                .get(`/decay-sales/listing-groupby-date/${season_id+'_'+id}`, {
                  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                })
                .then((response) => {
                  if (response.data.code === 200) {
                    setValue(response.data.data.groupby_date);
                    setData(response.data.data.sales);
                    // let sales =response.data.data.sales;
                    // const paidprice = sales.filter(item => item.payment_status === 1).reduce((sum, item) => sum + item.total_price, 0);
                    // const unpaidprice = sales.filter(item => item.payment_status === 0).reduce((sum, item) => sum + item.total_price, 0);
                    // setPaidprice(paidprice);
                    // setUunpaidprice(unpaidprice);
                    // console.log(paidprice);
 
          
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
                
                Swal.fire(
                  'Success!',
                  'Payment Status has been changed Successfully.',
                  'success'
                );
                // setTimeout(() => {
                //  // window.location.href = "/orders";
                // }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }


  const statusOptions =[
  {
      "id": 0,
      "title": "PENDING",
      "color": "white",
      "bg_color": "red",
  },
  {
      "id":1,
      "title": "PAID",
      "color": "white",
      "bg_color": "green",
  },
  ];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        {permission && permission.list == 1 && (
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-10">
                  <h3 className="page-title">Decay Sale Group By  Date</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/decay-sales">Decay Sales</Link>
                    </li>
                    <li className="breadcrumb-item active">
                    Decay Sale Group By  Date
                    </li>
                  </ul>
                </div>
                <div className="col-sm-2" style={{textAlign:"right"}}>
                 
               

               
               </div>
              </div>
            </div>
          
            <div className="row">
              
            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Sales</div>
                          <div className="dash-counts">
                            <p>{value.customer_total_price}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Quanity</div>
                          <div className="dash-counts">
                            <p>{value.quantity_total}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Payments </div>
                          <div className="dash-counts">
                            <p>{value.paid_amount}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div> 
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Open Amount </div>
                          <div className="dash-counts">
                            <p>{value.open_amount}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div> 
                       
                 </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Decay Sales Group By  Date</h4>
                      <table className="table table-bordered">
                        <tr>
                          <th className="p-3"> Date</th>
                          <td className="p-3">{value.date}</td>
                        </tr>
                        <tr>
                          <th className="p-3"> Operations</th>
                          <td className="p-3">{value.total_entries}</td>
                        </tr>
                       
                      </table>
                  </div>
                </div>
              </div>
            </div>
         
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                  <MaterialReactTable columns={columns} data={data} 
                          enableColumnOrdering
                          enablePinning
                          enableRowActions
                          renderColumnActionsMenuItems 
                            renderRowActionMenuItems={({ row }) => [
                            permission?.update == 1 && (
                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                Edit
                              </MenuItem>
                            ),
                            permission?.update == 1 && (
                              <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                                View
                              </MenuItem>
                            ),
                          permission?.delete == 1 && (
                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                  Delete
                                </MenuItem>
                              ),
                            ]}
                                    
                                    />
                  </div>
                </div>
              </div>
            </div>

           

          </div>
        </div>

  )}
      </div>
    </>
  );
};
export default DecaySaleGroupbyDate;
